import {View} from 'react-native-web'
import React from 'react'
import { Reply } from './Reply';



export const BookRoomSelect= props =>{
  return (
    <View style={{alignItems:'center', justifyContent:'space-between',width:'100%', height:'80%', marginTop:15}}>
                {props.risA? <Reply value1={props.risA} value={'- A -'} onPress={props.onPress}/>: <></>}
                {props.risB? <Reply value1={props.risB} value={'- B -'} onPress={props.onPress1}/>: <></>}
                {props.risC? <Reply value1={props.risC} value={'- C -'} onPress={props.onPress2}/>: <></>}
    </View>
  );}
